var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownDarkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.181,
    height: 7.082,
    viewBox: "0 0 13.181 7.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Arrow_2333164",
    transform: "translate(13.181 7.082) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35458",
    "data-name": "Group 35458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63867",
    "data-name": "Path 63867",
    d: "M6.018.227.237,5.741a.774.774,0,0,0,0,1.114.861.861,0,0,0,1.164,0L6.59,1.889,11.78,6.855a.861.861,0,0,0,1.164,0,.774.774,0,0,0,0-1.114L7.182.227A.861.861,0,0,0,6.018.227Z",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownDarkArrow);
export default __webpack_public_path__ + "static/media/down-dark-arrow.f10c0654bd0598c77d8bb2f85d751f95.svg";
export { ForwardRef as ReactComponent };